import { useEffect, useState, useCallback } from 'react';

// Tiny native-history router. React Router would be overkill for
// "two routes: / and /create-user", and it's one more dep that
// lives in the base bundle. popstate + pushState is a few lines.

export function usePath(): string {
  const [path, setPath] = useState<string>(() => window.location.pathname);
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    // Custom event lets navigate() notify peers in the same tab
    // without a full popstate (pushState doesn't fire popstate).
    window.addEventListener('lato:navigate', onPop as EventListener);
    return () => {
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('lato:navigate', onPop as EventListener);
    };
  }, []);
  return path;
}

export function useNavigate() {
  return useCallback((to: string) => {
    if (window.location.pathname + window.location.search + window.location.hash === to) return;
    window.history.pushState({}, '', to);
    window.dispatchEvent(new Event('lato:navigate'));
  }, []);
}

export function navigate(to: string): void {
  if (window.location.pathname + window.location.search + window.location.hash === to) return;
  window.history.pushState({}, '', to);
  window.dispatchEvent(new Event('lato:navigate'));
}
